import { NgModule, Component } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { LoginComponent } from './components/login/login.component';

import {DashboardComponent} from './components/dashboard/dashboard.component';
import {AuthGuardService as AuthGuard} from './services/auth/auth-guard.service';
import { CategoriaProductsComponent } from './modules/productos/categoria-productos/categoria-productos.component';
import { utensiliosComponent } from './modules/utensilios/categoria-utensilios/utensilios.component';
import { CategoriaParametrosComponent } from './modules/parametros/categoria-parametros/categoria-parametros.component';
import { tiritasComponent } from './modules/tiritas/categoria-tiritas/tiritas.component';
import {  PesosCreateComponent } from './modules/pesos/create/pesos.component';
import { PesosComponent } from './modules/pesos/pesos.component';
import { ListPesosComponent } from './modules/pesos/list/list-pesos/list-pesos.component';
import { UpdatePesosComponent } from './modules/pesos/update/updatePesos.component';
/* import { PesosGirsacComponent } from './modules/girsac/pesos.component'; */
import { ZumosCategoriaComponent } from './modules/zumos/zumos-categoria/zumos-categoria.component';
import { EtiquetaCategoriaComponent } from './modules/etiquetas/etiquetas-categoria/etiquetas-categoria.component';
import { UsuarioCategoriaComponent } from './modules/usuarios/usuarios-categoria/usuarios-categoria.component';
import { VariedadesCategoriaComponent } from './modules/variedades/variedades-categoria/variedades-categoria.component';
import { DocumentosComponent } from './components/documentos/documentos.component';
import { CategoriaTestVidaComponent } from './modules/test-de-vida/categoria-test-de-vida/categoria-test-de-vida.component';
import { CategoriaConformidadComponent } from './modules/conformidad/categoria-conformidad/categoria-conformidad.component';
import { CategoriaTransporteComponent } from './modules/transporte/categoria-transporte/categoria-transporte.component';
import { rellenarMenUsuario, getDocumento } from './config/procedimientos_registros';
import { informes } from './config/models';


function obtenerDocumento( documento ){
    try {
        let id_doc = getDocumento(documento);
        // console.log('id_doc',id_doc);
        
        if ( id_doc == null || id_doc.length == 0 ) { 
            return '';
        } else {
            return id_doc.full_title || '';
        }
    } catch (error) {
        return '';
    }
}

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'login'},
    { path:'login', component:LoginComponent},
   /*  { path: 'productos', component: ProductsComponent },
    { path: 'producto/crear', component: FormulariosComponent },
    { path: 'producto/:id', component: EditProductComponent },  */
    { 
        path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard],
        children: [
            { 
                path: 'inspeccion_pomelo_acabado',
                loadChildren: './modules/inspeccion-pomelo-acabado/inspeccion-pomelo-acabado.module#InspeccionPomeloAcabadoModule',
                data: {
                    titulo: obtenerDocumento('inspeccion_pomelo_acabado') || '' , id: "inspeccion_pomelo_acabado"
                }
            },
            { 
                path: 'registro_etiquetas',
                loadChildren: './modules/registro-etiquetas/registro-etiquetas.module#RegistroEtiquetasModule',
                data: {
                    titulo: obtenerDocumento('registro_etiquetas') || '' , id: "registro_etiquetas"
                }
            },
            { 
                path: 'inspeccion_pomelo_recibido',
                loadChildren: './modules/inspeccion-pomelo-recibido/inspeccion-pomelo-recibido.module#InspeccionPomeloRecibidoModule',
                data: {
                    titulo: obtenerDocumento('inspeccion_pomelo_recibido') || '' , id: "inspeccion_pomelo_recibido"
                }
            },
            { 
                path: 'inspeccion_pomelo_recibido_i',
                loadChildren: './modules/pomelo-recibido-importacion/pomelo-recibido-importacion.module#PomeloRecibidoImportacionModule',
                data: {
                    titulo: obtenerDocumento('inspeccion_pomelo_recibido_i') || '' , id: "inspeccion_pomelo_recibido_i"
                }
            },
            { 
                path: 'visita_campo',
                loadChildren: './modules/visita-campo/visita-campo.module#VisitaCampoModule',
                data: {
                    titulo: obtenerDocumento('visita_campo') || '' , id: "visita_campo"
                }
            },
            { 
                path: 'control_enmalladoras',
                loadChildren: './modules/control-enmalladoras/control-enmalladoras.module#ControlEnmalladorasModule',
                data: {
                    titulo: obtenerDocumento('control_enmalladoras0') || '' , id: "control_enmalladoras"
                }
            },
            { 
                path: 'limpieza',
                loadChildren:'./modules/limpieza/app.limpieza.modules#limpiezaModule',
                data: {
                    titulo: obtenerDocumento('limpieza') || '' , id: "limpieza"
                }
            },
            { 
                path: 'tiritas',
                component:tiritasComponent,
                loadChildren:'./modules/tiritas/app.tiritas.modules#TiritasModule',
                data: {
                    titulo: obtenerDocumento('tiritas') || '' , id: "tiritas"
                }
            }, 
            { 
                path: 'control',
                loadChildren:'./modules/control/app.control.modules#ControlCristalModule',
                data: {
                    titulo: obtenerDocumento('control') || '' , id: "control"
                }
            }, 
            {
                path: 'inspeccion_recoleccion_citricos',
                component:CategoriaProductsComponent,
                loadChildren:'./modules/productos/app.productos.modules#productModule',
                data: {
                    titulo: obtenerDocumento('inspeccion_recoleccion_citricos') || '' , id: "inspeccion_recoleccion_citricos"
                }
              
            },
            {
                path: 'instrumentos_afilados',
                component:utensiliosComponent,
                loadChildren:'./modules/utensilios/app.utensilios.modules#UtensiliosModule',
                data: {
                    titulo: obtenerDocumento('instrumentos_afilados') || '', id: "instrumentos_afilados"
                }
            },
            {
                path: 'parametro',
                component:CategoriaParametrosComponent,
                loadChildren:'./modules/parametros/app.parametros.modules#ParametrosModule'
                ,
                data: {
                    titulo: obtenerDocumento('parametro') || '' , id: "parametro"
                }
            },
            {
                path: 'pesos',
                component:PesosComponent,
                children:
                [
                    {path: '', component:ListPesosComponent}, 
                    {path: 'crear', component: PesosCreateComponent}, 
                    {path: 'edit/:id', component: UpdatePesosComponent}, 
                   /*  {path: 'albums', component: ArtistAlbumListComponent},  */
                ]
                //loadChildren:'./modules/parametros/app.parametros.modules#ParametrosModule'
               
            },
          /*   {
                path: 'girsac',
                loadChildren:'./modules/girsac/app.girsac.modules#GirsacModule'
                
               
            }, */
           

            { 
                path: 'zumos',
                component:ZumosCategoriaComponent,
                loadChildren:'./modules/zumos/app.zumos.modules#ZumosModule',
                data: {
                    titulo: obtenerDocumento('zumos') || '', id: "zumos"
                }
            }, 
            { 
                path: 'control_calidad_interna_citricos',
                loadChildren:'./modules/control-calidad-interna-citricos/app.control-calidad-interna-citricos.modules#ControlCalidadInternaCitricosModule',
                data: {
                    titulo: obtenerDocumento('control_calidad_interna_citricos') || '', id: "control_calidad_interna_citricos"
                }
            }, 
            { 
                path: 'etiquetas',
                component:EtiquetaCategoriaComponent,
                loadChildren:'./modules/etiquetas/app.etiquetas.modules#EtiquetasModule'
                ,
                data: {
                    titulo: obtenerDocumento('etiquetas') || '' , id: "etiquetas"
                }
            },
            { 
               
                path: 'usuarios',
                component:UsuarioCategoriaComponent,
                loadChildren:'./modules/usuarios/app.usuario.modules#UsuarioModule'
                ,
                data: {
                    titulo: obtenerDocumento('usuarios') || '' , id: "usuarios"
                }

            },
            { 
                
                path: 'variedades',
                component:VariedadesCategoriaComponent,
                loadChildren:'./modules/variedades/app.variedades.modules#VariedadesModule'
                ,
                data: {
                    titulo: obtenerDocumento('variedades') || '' , id: "variedades"
                }
            },
            { 
                
                path: 'ean_articulos',
                loadChildren:'./modules/ean-articulos/ean-articulos.module#EanArticulosModule'
                ,
                data: {
                    titulo: obtenerDocumento('ean_articulos') || '' , id: "ean_articulos"
                }
            },            
            { 
                
                path: 'paises',
                component:VariedadesCategoriaComponent,
                loadChildren:'./modules/paises/app.pasies.modules#PaisesModule'
            },
            
            {  
                path: 'empresas',
                component:CategoriaTransporteComponent,
                loadChildren:'./modules/empresas/app.empresas.modules#EmpresasModule'
            },
            
            {
                path: 'documentos',
                component:DocumentosComponent
                ,
                data: {
                    titulo: obtenerDocumento('documentos') || '' , id: "documentos"
                }
               
               
            },
            {  
                path: 'test_de_vida_comercial',
                component:CategoriaTestVidaComponent,
                loadChildren:'./modules/test-de-vida/app.test-de-vida.modules#TestVidaModule'
                ,
                data: {
                    titulo: obtenerDocumento('test_de_vida_comercial') || '' , id: "test_de_vida_comercial"
                }
            },
            {  
                path: 'test_vida_comercial_mallas',
                loadChildren:'./modules/test-de-vida-mallas/app.test-de-vida.modules#TestVidaComercialMallasModule'
                ,
                data: {
                    titulo: obtenerDocumento('test_vida_comercial_mallas') || '' , id: "test_vida_comercial_mallas"
                }
            },
            {  
                path: 'tratamiento_postcosecha_citricos',
                loadChildren:'./modules/tratamiento_postcosecha_citricos/app.tratamiento_postcosecha_citricos.modules#TratamientoPostcosechaCitricosModule' ,
                data: {
                    titulo: obtenerDocumento('tratamiento_postcosecha_citricos') || '' , id: "tratamiento_postcosecha_citricos"
                }
            },
            {  
                path: 'tratamiento_postcosecha_citricos_drencher',
                loadChildren:'./modules/tratamiento_postcosecha_citricos_drencher/app.tratamiento_postcosecha_citricos_drencher.modules#TratamientoPostcosechaCitricosDrencherModule' ,
                data: {
                    titulo: obtenerDocumento('tratamiento_postcosecha_citricos_drencher') || '' , id: "tratamiento_postcosecha_citricos_drencher"
                }
            },
            {  
                path: 'control-de-conformidad',
                component:CategoriaConformidadComponent,
                loadChildren:'./modules/conformidad/app.conformidad.modules#ConformidadModule' ,
                data: {
                    titulo: obtenerDocumento('control-de-conformidad') || '' , id: "control-de-conformidad"
                }
            },
            {  
                path: 'transporte_higiene',
                component:CategoriaTransporteComponent,
                loadChildren:'./modules/transporte/app.transporte.modules#ControlTransporteModule' ,
                data: {
                    titulo: obtenerDocumento('transporte_higiene') || '' , id: "transporte_higiene"
                }
            },
            {  
                path: 'transporte-rutas',
                component:CategoriaTransporteComponent,
                loadChildren:'./modules/transporte-rutas/app.transporte-rutas.modules#ControlTransporteRutasModule' 
            },
            {  
                path: 'mantenimiento-camiones',
                component:CategoriaTransporteComponent,
                loadChildren:'./modules/mantenimiento-camiones/app.mantenimiento-camiones.modules#ControlTransporteRutasModule' 
            },
            {  
                path: 'agua_cloro',
                component:CategoriaTransporteComponent,
                loadChildren:'./modules/agua-cloro/app.agua-cloro.modules#AguaCloroModule' ,
                data: {
                    titulo: obtenerDocumento('agua_cloro') || '' , id: "agua_cloro"
                }
            }, 
            {  
                path: 'agua',
                loadChildren:'./modules/agua/app.agua.modules#AguaModule' ,
                data: {
                    titulo: obtenerDocumento('agua') || '' , id: "agua"
                }
            },
            {  
                path: 'prod_camion',
                loadChildren:'./modules/prod_camion/app.prod_camion.modules#ProdCamionModule'
            },  
            {  
                path: 'control_l_d_expedicion',
                loadChildren:'./modules/control_l_d_expedicion/app.limpieza_camiones.modules#limpiezaCamionesModule' ,
                data: {
                    titulo: obtenerDocumento('control_l_d_expedicion') || '' , id: "control_l_d_expedicion"
                }
            },  
            {  
                path: 'control_l_d_produccion',
                loadChildren:'./modules/control_l_d_produccion/app.control_ld_produccion.modules#ControlLDProduccionModule' ,
                data: {
                    titulo: obtenerDocumento('control_l_d_produccion') || '' , id: "control_l_d_produccion"
                }
            },  
            {  
                path: 'control_l_d_recepcion',
                loadChildren:'./modules/control_l_d_recepcion/app.control_ld_recepcion.modules#ControlLDRecepcionModule' ,
                data: {
                    titulo: obtenerDocumento('control_l_d_recepcion') || '' , id: "control_l_d_recepcion"
                }
            },  
            {  
                path: 'prod_post_cosecha',
                loadChildren:'./modules/prod_post_cosecha/app.prod_post_cosecha.modules#ProdCosechaModule' ,
                data: {
                    titulo: obtenerDocumento('prod_post_cosecha') || '' , id: "prod_post_cosecha"
                }
            },  
            {  
                path: 'encerado',
                loadChildren:'./modules/encerado/app.encerado.modules#EnceradosModule' ,
                data: {
                    titulo: obtenerDocumento('encerado') || '' , id: "encerado"
                }
            },
            {  
                path: 'lavadora',
                loadChildren:'./modules/lavadora/app.lavadora.modules#LavadoraModule' ,
                data: {
                    titulo: obtenerDocumento('lavadora') || '' , id: "lavadora"
                }
            },
            {  
                path: 'etileno',
                loadChildren:'./modules/etileno/app.etileno.modules#EtilenoModule' ,
                data: {
                    titulo: obtenerDocumento('etileno') || '' , id: "etileno"
                }
            },
            {  
                path: 'nebulizador',
                loadChildren:'./modules/nebulizador/app.nebulizador.modules#NebulizadorModule' 
            },
            {  
                path: 'cuaderno_campo',
                loadChildren:'./modules/cuaderno-campo/app.cuaderno-campo.modules#CuadernoCampoModule' ,
                data: {
                    titulo: obtenerDocumento('cuaderno_campo') || '' , id: "cuaderno_campo"
                }
            },
            {  
                path: 'confecciones_diarias',
                loadChildren:'./modules/confecciones-diarias/app.confecciones-diarias.modules#ConfeccionDiariasModule' ,
                data: {
                    titulo: obtenerDocumento('confecciones_diarias') || '' , id: "confecciones_diarias"
                }
            },
            {  
                path: 'plagas',
                loadChildren:'./modules/plagas/app.plagas.modules#PlagasModule' ,
                data: {
                    titulo: obtenerDocumento('plagas') || '' , id: "plagas"
                }
            },
            {  
                path: 'camaras_etileno',
                loadChildren:'./modules/camaras-etileno/app.camaras-etileno.modules#CamarasEtilenoModule' ,
                data: {
                    titulo: obtenerDocumento('camaras_etileno') || '' , id: "camaras_etileno"
                }
            },
            {  
                path: 'residuos_peligrosos',
                loadChildren:'./modules/residuos-peligrosos/app.productos-peligrosos.modules#ProductoPeligrososModule' ,
                data: {
                    titulo: obtenerDocumento('residuos_peligrosos') || '' , id: "residuos_peligrosos"
                }
            },
            {  
                path: 'control_linea_citricos',
                loadChildren:'./modules/control-linea/app.control-linea.modules#ControlLineaModule' ,
                data: {
                    titulo: obtenerDocumento('control_linea_citricos') || '' , id: "control_linea_citricos"
                }
            },
            {  
                path: 'diario_cogida',
                loadChildren:'./modules/diario-cogida/app.diario-cogida.modules#DiarioCogidaModule' ,
                data: {
                    titulo: obtenerDocumento('diario_cogida') || '' , id: "diario_cogida"
                }
            },
            {  
                path: 'peso_materia',
                loadChildren:'./modules/peso-materia-prima/apppeso-materia.modules#PesoMateriaModule' ,
                data: {
                    titulo: obtenerDocumento('peso_materia') || '' , id: "peso_materia"
                }
            },
            {  
                path: 'perdida_peso_no_pesada',
                loadChildren:'./modules/perdida-peso-diaria-no-pesada/app.perdida-peso-diaria-no-pesada.modules#PerdidaPesoDiariaNoPesadaModule' ,
                data: {
                    titulo: obtenerDocumento('perdida_peso_no_pesada') || '' , id: "perdida_peso_no_pesada"
                }
            },
            {  
                path: 'perdida_peso_diaria',
                loadChildren:'./modules/perdida-peso-diaria/app.perdida-peso-diaria.modules#PerdidaPesoDiariaModule' ,
                data: {
                    titulo: obtenerDocumento('perdida_peso_diaria') || '' , id: "perdida_peso_diaria"
                }
            },
            {  
                path: 'contra_incendios',
                loadChildren:'./modules/contra-incendios/app.contra-incendios.modules#ContraIncendiosModule' ,
                data: {
                    titulo: obtenerDocumento('contra_incendios') || '' , id: "contra_incendios"
                }
            },
            {  
                path: 'plan_limpieza_desinfeccion',
                loadChildren:'./modules/plan-limpieza-desinfeccion/app.plan-limpieza-desinfeccion.modules#PlanLimiezaDesinfeccionModule' ,
                data: {
                    titulo: obtenerDocumento('plan_limpieza_desinfeccion') || '' , id: "plan_limpieza_desinfeccion"
                }
            },
            {  
                path: 'reuniones',
                loadChildren:'./modules/reuniones/app.reuniones.modules#ReunionesModule' ,
                data: {
                    titulo: obtenerDocumento('reuniones') || '' , id: "reuniones"
                }
            },
            {  
                path: 'formacion',
                loadChildren:'./modules/formacion/app.formacion.modules#FormacionModule' ,
                data: {
                    titulo: obtenerDocumento('formacion') || '' , id: "formacion"
                }
            },
            {  
                path: 'tratamiento_no_conformidad',
                loadChildren:'./modules/tratamiento-no-conformidad/app.tratamiento-no-conformidad.modules#TratamientoNoConformidadModule' ,
                data: {
                    titulo: obtenerDocumento('tratamiento_no_conformidad') || '' , id: "tratamiento_no_conformidad"
                }
            },
            {  
                path: 'control_documentos',
                loadChildren:'./modules/control-documentos/app.control-documentos.modules#ControlDocumentosModule' ,
                data: {
                    titulo: obtenerDocumento('control_documentos') || '' , id: "control_documentos"
                }
            },
            {  
                path: 'organigrama_funcional',
                loadChildren:'./modules/organigrama-funcional/app.organigrama-funcional.modules#OrganigramaFuncionalModule' ,
                data: {
                    titulo: obtenerDocumento('organigrama_funcional') || '' , id: "organigrama_funcional"
                }
            },
            {  
                path: 'encuesta_higiene',
                loadChildren:'./modules/encuesta-higiene/app.encuesta-higiene.modules#EncuestaHigieneModule' ,
                data: {
                    titulo: obtenerDocumento('encuesta_higiene') || '' , id: "encuesta_higiene"
                }
            },
            {  
                path: 'control_drencher',
                loadChildren:'./modules/control-drencher/app.control-drencher.modules#ControlDrencherModule' ,
                data: {
                    titulo: obtenerDocumento('control_drencher') || '' , id: "control_drencher"
                }
            },
            {  
                path: 'limpieza_cajones',
                loadChildren:'./modules/control-limpieza-cajones/app.limpieza-cajones-modules#ControlLimpiezaCajonesModule' ,
                data: {
                    titulo: obtenerDocumento('limpieza_cajones') || '' , id: "limpieza_cajones"
                }
            },
            {  
                path: 'micro_fomesa',
                loadChildren:'./modules/control-fomesa/app.micro-fomesa-modules#ControlMicroFomesaModule' ,
                data: {
                    titulo: obtenerDocumento('micro_fomesa') || '' , id: "micro_fomesa"
                }
            },
            {  
                path: 'calibre',
                loadChildren:'./modules/calibre/app.calibre.modules#AppCalibreModule' 
                
            },
            {  
                path: 'tipo_palet',
                loadChildren:'./modules/tipo_palet/app.tipo_palet.modules#AppTipoPaletModule'
            },  
            {  
                path: 'paletizacion',
                loadChildren:'./modules/paletizacion/app.paletizacion.modules#AppPaletizacionModule'
            }, 
            {  
                path: 'marcas-comerciales',
                loadChildren:'./modules/marcas-comerciales/app.calibre.modules#AppMarcasComercialesModule' 
            },
            {  
                path: 'presentacion',
                loadChildren:'./modules/presentacion/app.presentacion.modules#AppPresentacionModule'
            },
            {  
                path: 'categorias',
                loadChildren:'./modules/altas/categorias/app.categorias.modules#AppCategoriasModule'
            },
            {  
                path: 'confecciones',
                loadChildren:'./modules/altas/confecciones/app.confecciones.modules#AppConfeccionesModule' ,
                data: {
                    titulo: 'Confecciones' , id: "confecciones"
                }
            }, 
            {  
                path: 'transportistas',
                loadChildren:'./modules/altas/transportista/app.transportista.modules#AppTransportistaModule' ,
                data: {
                    titulo: 'Transportistas' , id: "transportistas"
                }
            }, 
            {  
                path: 'multiresiduos',
                loadChildren:'./modules/multiresiduos/app.multiresiduos.modules#MultiresidusosModule',
                data: {titulo : 'Control de análisis'}
               
            },          
            {  
                path: 'parte-ejecucion',
                loadChildren:'./modules/parte-ejecucion/app.parte-ejecucion.modules#ParteEjecucionModule',
                data: {titulo : 'Parte de Ejecucion'}
               
            },   
            {
                path: 'producto_embolsado',
                loadChildren:'./modules/peso-producto/app.envasado-bolsa.modules#EnvasadoBolsaModule' ,
                data: {
                    titulo: obtenerDocumento('producto_embolsado') || '' , id: "producto_embolsado"
                }
            },
            {
                path: 'encajado_bolsas',
                loadChildren:'./modules/encajado-bolsas/app.encajado-bolsas.modules#EncajadoBolsasModule' ,
                data: {
                    titulo: obtenerDocumento('encajado_bolsas') || '' , id: "encajado_bolsas"
                }
            },
            {
                path: 'clientes',
                loadChildren:'./modules/cliente/app.cliente.modules#AppClienteModule',
                data: {
                    titulo: obtenerDocumento('clientes') || '' , id: "clientes"
                }                
            },
            {
                path: 'proveedores',
                loadChildren:'./modules/proveedores/app.proveedores.module#AppProveedoresModule',
                data: {
                    titulo: obtenerDocumento('proveedores') || '' , id: "proveedores"
                }                
            },
            {
                path: 'agricultores',
                loadChildren:'./modules/agricultor/app.agricultor.module#AppAgricultorModule',
                data: {
                    titulo: obtenerDocumento('agricultores') || '' , id: "agricultores"
                }                
            },
            {
                path: 'cuadrillas',
                loadChildren:'./modules/cuadrillas/app.cuadrillas.modules#AppCuadrillasModule',
                data: {
                    titulo: obtenerDocumento('cuadrillas') || '' , id: "cuadrillas"
                }
            },
            {
                path: 'idiomas',
                loadChildren:'./modules/idiomas/app.idiomas.modules#AppIdiomasModule'
            },
            {
                path: 'tipo_envase',
                loadChildren:'./modules/tipo-envase/app.tipo-envase.modules#AppTipoEnvaseModule',
                data: {
                    titulo: obtenerDocumento('tipo_envase') || '' , id: "tipo_envase"
                }
            },
            {
                path: 'tipo_podrido',
                loadChildren:'./modules/tipo-podrido/app.tipo-podrido.modules#AppTipoPodridoModule',
                data: {
                    titulo: obtenerDocumento('tipo_podrido') || '' , id: "tipo_podrido"
                }
            },
            {
                path: 'peso_encajado_producto',
                loadChildren:'./modules/peso-producto-encajado/app.peso-producto-encajado.modules#PesoEncajadoProductoModule',
                data: {
                    titulo: obtenerDocumento('peso_encajado_producto') || '' , id: "peso_encajado_producto"
                }
            },
            {
                path: 'proceso_desverdizacion_etileno',
                loadChildren:'./modules/proceso-desverdizacion-etileno/app.proceso-desverdizacion-etileno.modules#ProcesoDesverdizacionEtilenoModule',
                data: {
                    titulo: obtenerDocumento('proceso_desverdizacion_etileno') || '' , id: "proceso_desverdizacion_etileno"
                }
            },
            {
                path: 'vidrio_plastico_duro',
                loadChildren:'./modules/vidrios-plasticos-duros/app.vidrios-plasticos-duros.modules#VidriosPlasticosDurosModule',
                data: {
                    titulo: obtenerDocumento('vidrio_plastico_duro') || '' , id: "vidrio_plastico_duro"
                }
            },
            {
                path: 'mantenimiento_correctivo',
                loadChildren:'./modules/mantenimiento-correctivo/app.mantenimiento-correctivo.modules#MantenimientoCorrectivoModule',
                data: {
                    titulo: obtenerDocumento('mantenimiento_correctivo') || '' , id: "mantenimiento_correctivo"
                }
            },
            {
                path: 'mantenimiento_preventivo_semanal',
                loadChildren:'./modules/mantenimiento-preventivo-semanal/app.mantenimiento-preventivo-semanal.modules#MantenimientoPreventivoSemanalModule',
                data: {
                    titulo: obtenerDocumento('mantenimiento_preventivo_semanal') || '' , id: "mantenimiento_preventivo_semanal"
                }
            },
            {
                path: 'mantenimiento_preventivo_anual',
                loadChildren:'./modules/mantenimiento-preventivo-anual/app.mantenimiento-preventivo-anual.modules#MantenimientoPreventivoAnualModule',
                data: {
                    titulo: obtenerDocumento('mantenimiento_preventivo_anual') || '' , id: "mantenimiento_preventivo_anual"
                }
            },
            {
                path: 'mantenimiento_preventivo_quincenal',
                loadChildren:'./modules/mantenimiento-preventivo-quincenal/app.mantenimiento-preventivo-quincenal.modules#MantenimientoPreventivoQuincenalModule',
                data: {
                    titulo: obtenerDocumento('mantenimiento_preventivo_quincenal') || '' , id: "mantenimiento_preventivo_quincenal"
                }
            },
            {
                path: 'higiene',
                loadChildren:'./modules/higiene/app.higiene.modules#HigieneModule',
                data: {
                    titulo: obtenerDocumento('higiene') || '' , id: "higiene"
                }
            },
            {
                path: 'mantenimiento_preventivo_locales',
                loadChildren:'./modules/mantenimiento-preventivo-locales/app.mantenimiento-preventivo-locales.module#MantenimientoPreventivoLocalesModule',
                data: {
                    titulo: obtenerDocumento('mantenimiento_preventivo_locales') || '' , id: "mantenimiento_preventivo_locales"
                }
            },        
            {
                path: 'plan_muestreo_analisis',
                loadChildren:'./modules/plan-muestreo-analisis/plan-muestreo-analisis.modules#PlanMuestreoAnalisisModule',
                data: {
                    titulo: obtenerDocumento('plan_muestreo_analisis') || '' , id: "plan_muestreo_analisis"
                }
            },        
            {
                path: 'inspeccion_podrido_citricos',
                loadChildren:'./modules/inspeccion-podrido-citricos/inspeccion-podrido-citricos.modules#InspeccionPodridoCitricosModule',
                data: {
                    titulo: obtenerDocumento('inspeccion_podrido_citricos') || '' , id: "inspeccion_podrido_citricos"
                }
            },        
            {
                path: 'vigilancia_generica',
                loadChildren:'./modules/vigilancia-generica/vigilancia-generica.modules#VigilanciaGenericaModule',
                data: {
                    titulo: obtenerDocumento('vigilancia_generica') || '' , id: "vigilancia_generica"
                }
            }, 
            {
                path: 'control_proceso_desastringencia',
                loadChildren:'./modules/desastringencia/app.desastringencia.module#DesastringenciaModule',
                data: {
                    titulo: obtenerDocumento('control_proceso_desastringencia') || '' , id: "control_proceso_desastringencia"
                }
            },       
            
            {
                path: 'calidad_producto_final',
                loadChildren:'./modules/calidad_producto_final/app.calidad_producto_final.module#AppCalidadProductoFinalModule',
                data: {
                    titulo: obtenerDocumento('calidad_producto_final') || '' , id: "calidad_producto_final"
                }
            },       
            {
                path: 'fitosanitario',
                loadChildren:'./modules/fitosanitario/app.fitosanitario.modules#AppFitosanitarioModuleModule',
                data: {
                    titulo: 'Producto fitosanitario', 
                    id: 'Producto fitosanitario', 
                }
            },       
            
        ]
    },
    {
        path: '',
        redirectTo: '',
        pathMatch: 'full'
      },
        
    { path: '**', redirectTo: 'login' },
];

 let auxMenu = rellenarMenUsuario();
// console.log('auxMenu', auxMenu);

 for (let index = 0; index < routes.length; index++) {
    const element = routes[index];
    if ( element.path.localeCompare('dashboard') == 0 ){
        for (let index1 = 0; index1 < element.children.length; index1++) {
            const element1 = element.children[index1];
            const path = element.children[index1].path;
            for (let index2 = 0; index2 < auxMenu.length; index2++) {
                const element2 = auxMenu[index2];
                 //console.log('element2', element2.id, 'path', path);
                if ( (element2.id as string).localeCompare(path) == 0 ){
                    element1['data'] = { titulo: element2.text || '', id: element2.id };
                   // console.log('element', element.children[index1]);
                    
                }
            }
           
           
            
        }
    }
    
} 
// console.log('routes', routes);
 
@NgModule({
    imports: [RouterModule.forRoot(routes )],
    exports: [RouterModule]
})
export class AppRoutingModule {}
